// Handles showing/hidding/scrolling to an alert

import { useState, useCallback, useMemo, useRef } from 'react'
import { Alert } from 'reactstrap'
import { isInView } from '~/lib/helpers/isInView'

function useAlert () {
  const ref = useRef()
  const [message, setMessage] = useState()
  const [color, setColor] = useState('success')
  const [className, setClassName] = useState('')

  // Set message functions
  const setAlert = useCallback((message, color, customClassName) => {
    setMessage(message)
    setColor(color)
    setClassName(customClassName)
    if (ref && ref.current && !isInView(ref.current) && message) {
      ref.current.scrollIntoView()
    }
  }, [])
  const setSuccess = useCallback((message, customClassName) => {
    setAlert(message, 'success', customClassName || '')
  }, [])
  const setDanger = useCallback((message, customClassName) => {
    setAlert(message, 'danger', customClassName || '')
  }, [])

  // Alert to render
  const alert = useMemo(() => {
    return (
      <div ref={ref}>
        {message && <Alert className={className} color={color}>{message}</Alert>}
      </div>
    )
  }, [color, message])

  return [alert, setSuccess, setDanger]
}

export default useAlert
